
import { User, SwitchButton } from "@element-plus/icons-vue";
import { useRouter } from "vue-router";
import { defineComponent, ref } from "vue";
export default defineComponent({
  name: "Head",
  setup() {
    const router = useRouter();
    const isloginout = ref(false);
    const userinfo = JSON.parse(localStorage.getItem("userInfo") as string);
    const defaultImg = ref("");
    const outLogin = () => {
      isloginout.value = true;
    };
    const isPushSuccess = () => {
      isloginout.value = false;
      router.replace({ path: "/login" });
      location.reload();
    };
    return { User, SwitchButton, outLogin, userinfo, defaultImg, isloginout, isPushSuccess };
  },
});
